var map = {
	"./desktop-afraid.png": "9926",
	"./desktop-background.png": "a06a",
	"./desktop-default.png": "4dfc",
	"./desktop-for-business.png": "873e",
	"./desktop-hit-a-wall.png": "fac5",
	"./desktop-pressure.png": "7d58",
	"./desktop-resolutions-short-lived.png": "2823",
	"./mobile-afraid.png": "5b07",
	"./mobile-background.png": "e19c",
	"./mobile-default.png": "a642",
	"./mobile-for-business.png": "b9d1",
	"./mobile-hit-a-wall.png": "c58b",
	"./mobile-pressure.png": "3e2a",
	"./mobile-resolutions-short-lived.png": "a232"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac0f";